import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionDocumentSeries  {
    _originalTypeClassName = "zERP.BO.TransactionDocumentSeries";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionDocumentSeries.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.Series = null;
this.NextNumber = null;
this.InvoiceType = null;
this.InvoiceTypeString = null;
this.IsExternal = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Series:any;
NextNumber:any;
InvoiceType:any;
InvoiceTypeString:any;
IsExternal:any;
Entity:any;
InvoiceTypeValueObject:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setInvoiceTypeValueObject = ($this, value) => {
var oldValue = $this.InvoiceTypeValueObject;
$this.InvoiceTypeValueObject = value;
if (value != null) {
}
}

static GetInvoiceTypeString($this: any): any{if ($this?.InvoiceTypeValueObject != null && !(Domain.InvoiceTypeValueObject.IsNew($this?.InvoiceTypeValueObject))) {return Domain.InvoiceTypeValueObject.InvoiceTypeToString($this?.InvoiceTypeValueObject?.Code);}
return Domain.InvoiceTypeValueObject.InvoiceTypeToString($this?.InvoiceType);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}